'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        color: variables.COLORS.GREEN,
        height: "24px",
        "&$disabled": {
            color: variables.COLORS.GREYSCALE_0_15,
        },
    },
    rail: {
        backgroundColor: variables.COLORS.GREYSCALE_0_05,
        height: "4px",
        opacity: "1",
        border: `solid 1px ${variables.COLORS.GREYSCALE_0_05}`,
        borderRadius: variables.SIZES.BORDER_RADIUS,
        boxShadow: `inset 0px 0px 0px 1px ${variables.COLORS.GREYSCALE_0_05}`,
    },
    track: {
        height: "4px",
        backgroundColor: "currentColor",
        opacity: "1",
        border: `solid 1px ${variables.COLORS.GREYSCALE_0_05}`,
        borderRadius: variables.SIZES.BORDER_RADIUS,
    },
    thumb: {
        height: "16px",
        width: "16px",
        borderRadius: variables.SIZES.BORDER_RADIUS,
        backgroundColor: variables.COLORS.WHITE,
        boxShadow: `0px 1px 2px 0px ${variables.COLORS.GREYSCALE_0_15}, 0px 0px 0px 1px ${variables.COLORS.GREYSCALE_0_05}`,
        "&:hover": {
            borderRadius: variables.SIZES.BORDER_RADIUS,
            boxShadow: `0 2px 4px 0 ${variables.COLORS.GREYSCALE_0_30}, 0 0 0 1px ${variables.COLORS.GREYSCALE_0_06}`,
        },
        "&:focus": {
            boxShadow: `0 1px 2px 0 ${variables.COLORS.GREYSCALE_0_15}, 0 0 0 1px ${variables.COLORS.GREYSCALE_0_06}, 0 0 0 2px ${variables.COLORS.MISC_FOCUS_BORDER}`,
        },
        "&$disabled": {
            width: "16px",
            height: "16px",
            marginTop: "-5px",
            marginLeft: "-8px",
            backgroundColor: variables.COLORS.GREYSCALE_90,
        },
        "& .bar": {
            height: "8px",
            width: "1px",
            backgroundColor: variables.COLORS.GREYSCALE_0_30,
            marginLeft: 1,
            marginRight: 1,
        },
    },
    mark: {
        width: "1px",
        height: "4px",
        margin: "16px 0px 0px 0px",
        backgroundColor: variables.COLORS.GREYSCALE_0_15,
    },
    markActive: {
        opacity: 1,
        backgroundColor: variables.COLORS.GREYSCALE_0_15,
    },
    markLabel: {
        color: variables.COLORS.TEXT_SECONDARY,
        transform: "translateX(-50%)",
        top: "35px",
    },
    markLabelActive: {
        color: variables.COLORS.TEXT_SECONDARY,
        transform: "translateX(-50%)",
        top: "35px",
    },
    active: {},
};

var MuiSlider = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiSlider = MuiSlider;
exports.light = light;
